import React from 'react';
import { Formik } from 'formik';

import AlertBox from '@RHEnvironmental/pattern-library/dist/js/components/AlertBox';
import InputContainer from '@RHEnvironmental/pattern-library/dist/js/components/InputContainer';
import InputLabel from '@RHEnvironmental/pattern-library/dist/js/components/InputLabel';
import Input from '@RHEnvironmental/pattern-library/dist/js/components/Input';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';

import { useDispatch } from 'react-redux';
import officerInviteApi from '../../../services/api/officerInviteApi';
import { setAlert } from '../../../actions/alerts';
import SelectBox from "@RHEnvironmental/pattern-library/dist/js/components/SelectBox";
import {roleDetails} from "../../../services/roles";
import {RoleOption} from "../../../types/enums/Role";

const OfficerInvite = ({ onSuccess, serviceProviderId = null }) => {
    const dispatch = useDispatch();

    const initialFormValues = {
        invites: '',
        service_provider_id: serviceProviderId,
        role_ids: RoleOption.Inspector.toString(),
    };

    const initialFormStatus = {
        errorMessage: null,
    };

    const cleanupEmailList = (emailList) => emailList.split(',');

    const onSubmit = async (values, { setSubmitting, resetForm }) => {
        const invites = cleanupEmailList(values.invites);

        try {
            await officerInviteApi.inviteOfficersByEmail({
                invites,
                service_provider_id: serviceProviderId,
                role_ids: [values.role_ids],
            });

            resetForm({ values: initialFormValues });
            onSuccess();

            dispatch(
                setAlert(
                    'Officers invited successfully.',
                    'success',
                    'settings'
                )
            );
        } catch ({ response }) {
            dispatch(
                setAlert(
                    'There was a problem inviting your officers.',
                    'error',
                    'settings'
                )
            );
        } finally {
            setSubmitting(false);
        }
    };

    const roleOptions = Object.keys(roleDetails).filter((key) => key !== RoleOption.PlatformAdmin.toString()).map((roleKey) => {
      return <option key={roleKey} value={roleDetails[roleKey].value}>{roleDetails[roleKey].name}</option>
    });

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={initialFormValues}
            initialStatus={initialFormStatus}
        >
            {({ values, status, handleChange, handleSubmit, isSubmitting }) => (
                <form onSubmit={handleSubmit}>
                    {status.errorMessage && (
                        <AlertBox
                            theme="error"
                            className="global-form-error mb-4"
                        >
                            {status.errorMessage}
                        </AlertBox>
                    )}
                    <InputContainer>
                        <InputLabel htmlFor="invites" show>
                            Invite an officer by email, or a comma separated
                            list of officer emails
                        </InputLabel>
                        <Input
                            id="invites"
                            onChange={handleChange}
                            value={values.invites}
                            aria-required="true"
                            name="invites"
                            type="text"
                        />
                      <SelectBox
                        name="role_ids"
                        defaultValue={values.role_ids}
                        aria-required="true"
                        controlFunc={handleChange}
                      >
                        {roleOptions}
                      </SelectBox>
                    </InputContainer>
                    <Button
                        type="submit"
                        disabled={isSubmitting || !values.invites}
                    >
                        Send invites
                    </Button>
                </form>
            )}
        </Formik>
    );
};

export default OfficerInvite;
